import { render, staticRenderFns } from "./CopyButton.vue?vue&type=template&id=205156f9&scoped=true&"
import script from "./CopyButton.vue?vue&type=script&lang=ts&"
export * from "./CopyButton.vue?vue&type=script&lang=ts&"
import style0 from "./CopyButton.vue?vue&type=style&index=0&id=205156f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205156f9",
  null
  
)

export default component.exports